import { render, staticRenderFns } from "./Layout1x2.vue?vue&type=template&id=62fd3224&scoped=true&"
import script from "./Layout1x2.vue?vue&type=script&lang=js&"
export * from "./Layout1x2.vue?vue&type=script&lang=js&"
import style0 from "./Layout1x2.vue?vue&type=style&index=0&id=62fd3224&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fd3224",
  null
  
)

export default component.exports